<script lang="ts">
import { defineAsyncComponent } from 'vue';

export default defineAsyncComponent(() => import('./brand-snippet.vue'));
</script>
